export enum TrackName {
  Add_property_confirmation = 'Helios add property confirmation',
  Duplicate_property_confirmation = 'Helios duplicate property confirmation',
  Publish_property_confirmation = 'Helios publish property confirmation',
}
